import React, { useState } from 'react';
import { Button, Col, Modal, Row } from 'antd';
const StudentModal = ({
    data,
    open,
    onCancel = () => {

    },
    onOk = () => {

    },
    onClick = () => {

    }
}) => {
    const role = true
    const leaveType = ["出席", "事假", "病假", "其他"]
    const handleClick = (val) => {
        Modal.confirm({
            title: '提示',
            content: `確認${data.name}${val}`,
            onOk: () => onClick(val),
            okButtonProps: {
                style: {
                    backgroundColor: "rgb(100,191,183)"
                }
            }
        })
    }
    return (
        <>
            <Modal open={open} onOk={() => onOk()} onCancel={() => onCancel()}>
                <Row>
                    <Col span={24}>
                        <Row justify={"center"}>
                            <img
                                style={{
                                    position: "relative",
                                    height: "150px",
                                    width: "150px",
                                    overflow: "hidden",
                                    borderRadius: "50%",
                                    padding: "5%"
                                }}
                                draggable={false}
                                alt="example"
                                src={data.src} />
                        </Row>
                    </Col>
                    <Col />
                    <Col span={24} >
                        <Row justify={"center"} style={{ fontSize: "24px" }}>
                            {data.name}
                        </Row>
                    </Col>
                    <Col span={24} >
                        <Row>
                            <Col span={12} style={{ borderRight: "1px solid rgb(230,230,230)" }}>
                                <Row>
                                    <Col span={24} style={{ paddingBlock: "10%" }}>
                                        <Row justify={"center"}>
                                            學生
                                        </Row>
                                    </Col>
                                    <Col span={24} style={{ paddingBlock: "10%" }} >
                                        <Row justify={"center"}>
                                            {data.checkIn ?
                                                <div
                                                    style={{
                                                        backgroundColor: "rgb(233,253,233)",
                                                        borderRadius: "50px",
                                                        padding: "5%"
                                                    }}
                                                >
                                                    已打卡
                                                </div>
                                                :
                                                <div
                                                    style={{
                                                        backgroundColor: "rgb(251,236,240)",
                                                        borderRadius: "50px",
                                                        padding: "5%"
                                                    }}
                                                >
                                                    未打卡
                                                </div>
                                            }
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12} style={{ borderLeft: "1px solid rgb(230,230,230)" }}>
                                <Row>
                                    <Col span={24} style={{ paddingBlock: "10%" }}>
                                        <Row justify={"center"}>
                                            老師
                                        </Row>
                                    </Col>
                                    <Col span={24} style={{ paddingBlock: "10%" }}>
                                        <Row justify={"center"}>
                                            {
                                                role ?
                                                    <>
                                                        <div
                                                            style={{
                                                                backgroundColor: "rgb(233,253,233)",
                                                                borderRadius: "50px",
                                                                padding: "5%"
                                                            }}
                                                        >
                                                            已確認出席
                                                        </div>
                                                    </>
                                                    :
                                                    <Col span={24}>
                                                        <Row>
                                                            <Col span={24} style={{ padding: "2%" }}>
                                                                <Row justify={"center"}>
                                                                    <Button onClick={() => handleClick("確認出席")}>
                                                                        確認出席
                                                                    </Button>
                                                                </Row>
                                                            </Col>
                                                            <Col span={24} style={{ padding: "2%" }}>
                                                                <Row justify={"center"}>
                                                                    <Button onClick={() => handleClick("未到")}>
                                                                        未到
                                                                    </Button>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                            }
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    {role &&
                        <Col span={24} style={{ paddingBlock: "5%", borderTop: "2px solid rgb(230,230,230)" }} >
                            <Row >
                                {leaveType.map((tmp, index) => (
                                    <Col key={index} span={6}>
                                        <Row justify={"center"}>
                                            <Button onClick={() => handleClick(tmp)}>
                                                {tmp}
                                            </Button>
                                        </Row>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    }
                </Row>
            </Modal>
        </>
    );
};
export default StudentModal;